import React, { useState } from "react";
import "./styles.scss";
import "./mobile.scss";
import { withRouter } from "react-router-dom";
import {
  BusinessNews,
  FeaturesNews,
  ForeignNews,
  HotNews,
  MainNews,
  SportsNews,
} from "../home/templates";
import { NewsCard, NewsGroup } from "../../components";
//import NewsViewPage from "./newsViewPage";

const Index = (props) => {
  const { location } = props;
  const [active, setActive] = useState("");

  const goToPage = (key) => {
    console.log("key", key);
    setActive("");
    switch (key) {
      case "news-view":
        props.history.push("/hotnews/news-view");
        break;
    }
  };
  return (
    <>
      {/* {location.pathname === "/hotnews" && ( */}
      <>
        <div className={`hot-news-wrapper`}>
          <div className={"hw__special-news-group"}>
            <div className={"hwsng__advertiesment"}>Advertisement with us </div>
            <NewsGroup
              data={{
                titleName: "උණුසුම් පුවත්",
                linkName: "තවත් උණුසුම් පුවත්",
              }}
              onClickViewNews={() => {
                //goToPage("news-view");
                props.history.push("/hotnews/news-view");
              }}
            >
              <NewsCard data={{ type: "large", isBorder: true }} />
              <NewsCard data={{ type: "large", isBorder: true }} />
              <NewsCard data={{ type: "large", isBorder: true }} />
              <NewsCard data={{ type: "large", isBorder: true }} />
              <NewsCard data={{ type: "large", isBorder: true }} />
            </NewsGroup>
          </div>
          <div className={"hw__special-news-group"}>
            <div className={"home__advertiesment"}>Advertisement with us </div>
            <ForeignNews />
          </div>
        </div>
      </>
      {/* )}
      {location.pathname === "/hotnews/news-view" && (
        <> */}
      {/* <NewsViewPage /> */}
      {/* </>
      )} */}
    </>
  );
};
//export default Index;

export default withRouter(Index);
